import { get, post, put } from '@api/request';

export const fetchBatchProcessings = async (
  { queueService },
  authenticationToken,
) => {
  const url = `${queueService}/queue/batchprocessing`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchBatchProcessing = async (
  { queueService },
  authenticationToken,
  { batchID },
) => {
  const url = `${queueService}/queue/batchprocessing/${batchID}`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const createProcessing = async (
  { queueService },
  authenticationToken,
  payload,
) => {
  const url = `${queueService}/queue/batchprocessing`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const fetchBarcodeFormats = async (
  { queueService },
  authenticationToken,
) => {
  const url = `${queueService}/queue/barcodeformats`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const findLinkedObject = async (
  { queueService },
  authenticationToken,
  { barcodeData, barcodeFormat },
) => {
  const url = `${queueService}/queue/barcodelookup?barcodeData=${barcodeData}&barcodeFormat=${barcodeFormat}`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const createWorkItems = async (
  { queueService },
  authenticationToken,
  { batchID, payload },
) => {
  const url = `${queueService}/queue/batchprocessing/${batchID}/groups`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const fetchCompletedItems = async (
  { queueService },
  authenticationToken,
  { batchID },
) => {
  const url = `${queueService}/queue/batchprocessing/${batchID}/completeitems`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchPendingItems = async (
  { queueService },
  authenticationToken,
  { batchID },
) => {
  const url = `${queueService}/queue/batchprocessing/${batchID}/pendingitems`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchErrorItems = async (
  { queueService },
  authenticationToken,
  { batchID },
) => {
  const url = `${queueService}/queue/batchprocessing/${batchID}/erroritems`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const closeProcess = async (
  { queueService },
  authenticationToken,
  { batchID },
) => {
  const url = `${queueService}/queue/batchprocessing/${batchID}/complete`;
  const { body } = await put(authenticationToken, url);
  return body;
};

export const validateLinkedObjects = async (
  { queueService },
  authenticationToken,
  { payload },
) => {
  const url = `${queueService}/queue/batchprocessing/validatelinkedobjects`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const updateTransaction = async (
  { queueService },
  authenticationToken,
  { payload },
) => {
  const url = `${queueService}/queue/batchprocessinggroup/transaction/4068`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const generatePreSignedURL = async (
  { queueService },
  authenticationToken,
  { file },
) => {
  const url = `${queueService}/queue/generatepresignedurl/${file}`;
  const { body } = await post(authenticationToken, url);
  return body;
};
